module.exports = __webpack_public_path__ + "img/bhs_scholarship_portal3.e196db16.png";